import React, { useState } from 'react'

const CoreComponent36 = ({ pokerdevcompany }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null)

  return (
    <div>
      <div className="row d-flex justify-content-center">
        {pokerdevcompany.map((val, i) => (
          <div
            key={i}
            className="col-md-4 text-center d-flex justify-content-between"
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div
  className="p-3 bg-light"
  style={{
    minHeight: 345,
    marginBottom: 30,
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    transform: hoveredIndex === i ? "scale(1.05)" : "scale(1)",
    boxShadow:
      hoveredIndex === i ? "0 10px 20px rgba(0,0,0,0.2)" : "none",

    // Gradient border
    // border: "3px solid", // required
    // borderImage: "linear-gradient(90deg, #F15A24 0%, #F1CC31 100%) 1",
    borderRadius: "10px", // optional for rounded gradient edges
  }}
>
              <img
                src={val.icon}
                alt=""
                className="mb-3 pb-1 mt-1 icon-logo"
                style={{
                  width: hoveredIndex === i ? 70 : 50,
                  height: hoveredIndex === i ? 70 : 50,
                  transition: 'all 0.3s ease',
                }}
              />
              <h3
                className="h3-heading fs-5 mb-2"
                style={{
                  transform: hoveredIndex === i ? 'scale(1.1)' : 'scale(1)',
                  transition: 'transform 0.3s ease',
                }}
              >
                {val.title}
              </h3>
              <p
                className="h3-para lh-base fs-6"
                style={{
                  transform: hoveredIndex === i ? 'scale(1.05)' : 'scale(1)',
                  transition: 'transform 0.3s ease',
                }}
              >
                {val.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CoreComponent36
